import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export default [
    {
        auth: authRoles.admin,
        routes: [{ path: '/route-centerpoints', component: FuseLoadable({ loader: () => import('./RouteCenterpointApp') }) }],
    },
];
